<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import DatePicker from "vue2-datepicker";
export default {
    components: {
        DatePicker
    },
    props: {
        modalTitle: {
            type: String,
            default: "Request for Obligation"
        },
    },
    validations: {
        rfp: {
            particulars: { required },
            rfpDate: { required }
        }
    },
    data() {
        return {
            rfp: {
                id: 0,
                particulars: "",
                rfpDate: new Date()
            },
            submitted: false,
        };
    },
    methods: {
        onReset(item) {
            this.rfp = {
                id: 0,
                particulars: "",
                rfpDate: new Date()
            };
            this.rfp.particulars = `Payment to ${item.supplierName}`
        },
        updateData(item) {
            this.rfp = {
                id: item.id,
                particulars: item.particulars,
                rfpDate: new Date(item.rfpDate)
            };
        },
        onCreateRFP() {
            this.submitted = true;
            this.$v.rfp.$touch();
            if (this.$v.rfp.$invalid) {
                return;
            }
            let data = cloneDeep(this.rfp);
            data.rfpDate = this.getDate(this.rfp.rfpDate);
            this.$emit('submit', data)
        }
    }
}
</script>
<template>
    <b-modal
        id="order-details-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form 
            @submit.prevent="onCreateRFP" 
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="rfpDate">Date Posted </label>
                <date-picker
                    v-model="rfp.rfpDate"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Date Posted..."
                    :class="{ 'is-invalid': submitted && $v.rfp.rfpDate.$error }"
                ></date-picker>
                <div
                    v-if="submitted && $v.rfp.rfpDate.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.rfp.rfpDate.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="description">Particulars </label>
                <textarea
                    id="description"
                    rows="3"
                    v-model="rfp.particulars"
                    placeholder="Enter Particulars..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && $v.rfp.particulars.$error,
                    }"
                ></textarea>
                <div
                    v-if="submitted && $v.rfp.particulars.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.rfp.particulars.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    <i class="bx bx-check"></i> {{rfp.id != 0 ? 'Update' : 'Submit'}} Request
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('order-details-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>